import { render, staticRenderFns } from "./SosSwitch.vue?vue&type=template&id=4055d48d&lang=pug"
import script from "./SosSwitch.vue?vue&type=script&lang=js"
export * from "./SosSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports